<template>
  <div>
    <dialog-add-contact ref="DialogAddContact" />

    <v-form :key="keyForm" v-model="valid">
      <v-container>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field v-model="form.companyName" label="Наименование организации" required></v-text-field>
          </v-col>

          <v-col cols="12" md="12">
            <v-text-field v-model="form.fullCompanyName" label="Полное наименование организации" required></v-text-field>
          </v-col>

          <v-col cols="12" md="12">
            <v-text-field v-model="form.legalAddress" label="Юридический адрес" required></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="form.inn" label="ИНН" required></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="form.kpp" label="КПП" required></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="form.ogrn" label="ОГРН" required></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="form.bank" label="Банк" required></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="form.bik" label="БИК" required></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="form.account" label="Расчетный счет" required></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="form.corrAccount" label="Корреспонденсткий счет" required></v-text-field>
          </v-col>


          <v-col cols="12" md="6">
            <v-text-field v-model="form.signatoryFIO" label="Подписант ФИО" required></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="form.signatoryPosition" label="Подписант должность" required></v-text-field>
          </v-col>

          <v-col cols="12" md="12">
            <v-text-field v-model="form.signatoryCause" label="Основание для подписи (Приказ №,..)" required></v-text-field>
          </v-col>


        </v-row>


        <v-data-table :headers="headersContacts" :items="form.contacts" class="elevation-1">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Контактные лица</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class="mb-2" @click="clickAddContact"> Добавить </v-btn>
            </v-toolbar>
          </template>

          <!-- <template v-slot:no-data>
            <v-btn color="primary" @click="initialize"> Reset </v-btn>
          </template> -->

          <template v-slot:[`item.actions`]="{ item, index }">
            <v-icon small class="mr-2" @click="editItemContact(item, index)"> mdi-pencil </v-icon>
            <v-icon small @click="deleteItemContact(item, index)"> mdi-delete </v-icon>
          </template>
        </v-data-table>
        <v-row class="mt-1">
          <v-col cols="12" md="12">
            <v-spacer></v-spacer>
            <v-btn @click="btnSave()" color="primary" >{{$t("common.button_save")}}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>


  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"


import DialogAddContact from "@/components/dialogs/DialogAddContact.vue"

export default {
  name: "PropsPage",
  components: { DialogAddContact, },

  data() {
    return {
      keyForm: new Date().getTime(),
      form: {
        companyName:"",
        fullCompanyName:"",
        legalAddress:"",
        inn:"",
        kpp:"",
        ogrn:"",
        bank:"",
        bik:"",
        account:"",
        corrAccount:"",
        signatoryFIO:"",
        signatoryPosition:"",
        signatoryCause:"",
        contacts:[]
      },

      headersContacts: [
        { text: "ФИО", value: "fio" },
        { text: "Должность", value: "position" },
        { text: "Телефон", value: "phone" },
        { text: "Почта", value: "email" },
        { text: "", value: "actions", sortable: false },
      ],

    }
  },
  methods: {
    ...mapActions('app',["apiUserUpdateInfo"]),

    btnSave(){
      console.log('btnSave')

      let payload = {
        companyName: this.form.companyName,
        fullCompanyName:this.form.fullCompanyName,
        legalAddress:this.form.legalAddress,
        inn:this.form.inn,
        kpp:this.form.kpp,
        ogrn:this.form.ogrn,
        bank:this.form.bank,
        bik:this.form.bik,
        account:this.form.account,
        corrAccount:this.form.corrAccount,
        signatoryFIO:this.form.signatoryFIO,
        signatoryPosition:this.form.signatoryPosition,
        signatoryCause:this.form.signatoryCause,
        contacts: this.form.contacts
      }

      this.apiUserUpdateInfo(payload)
    },

    async editItemContact(item, index) {
      console.log('item',item, index)
      const contact = this.form.contacts[index]
      console.log('contact',contact)

      const result = await this.$refs.DialogAddContact.show({
        fio:contact.fio,
        position:contact.position,
        phone:contact.phone,
        email:contact.email
      })
      console.log(result)
      if (result.answer==="positive"){
        console.log('positive')
        this.form.contacts[index]={
          fio: result.form.fio,
          position: result.form.position,
          phone: result.form.phone,
          email: result.form.email
        }
        this.keyForm = new Date().getTime()
        this.btnSave()
      }


    },

    async deleteItemContact(item, index) {
      console.log('deleteItemContact',item, index)
      //console.log('DialogYesNo',this.appRefs.DialogYesNo)
      const result = await this.appRefs.DialogYesNo.show({
        title: this.$t("common.title_warning"),
        message: "Вы уверены что хотите удалить этот контакт?",
        negative: this.$t("common.button_cancel"),
        positive: this.$t("common.button_yes"),
      })
      if (result.answer === "positive") {
        console.log('positive')
        this.form.contacts.splice(index,1)
        this.keyForm = new Date().getTime()
        this.btnSave()
      }


    },

    async clickAddContact() {
      console.log("add contact")
      const result = await this.$refs.DialogAddContact.show({
        fio:"", position:"",phone:"",email:""
      })

      console.log(result)
      if (result.answer==="positive"){
        console.log('positive')
        this.form.contacts.push(
            {
              fio: result.form.fio,
              position: result.form.position,
              phone: result.form.phone,
              email: result.form.email
            }
        )
        this.keyForm = new Date().getTime()
        this.btnSave()
      }

      console.log(result)
    },

    loadForm(){
      this.form.companyName       = this.getUserInfo.companyName
      this.form.fullCompanyName   = this.getUserInfo.fullCompanyName
      this.form.legalAddress      = this.getUserInfo.legalAddress
      this.form.inn               = this.getUserInfo.inn
      this.form.kpp               = this.getUserInfo.kpp
      this.form.bank              = this.getUserInfo.bank
      this.form.bik               = this.getUserInfo.bik
      this.form.ogrn              = this.getUserInfo.ogrn
      this.form.account           = this.getUserInfo.account
      this.form.corrAccount       = this.getUserInfo.corrAccount
      this.form.signatoryFIO      = this.getUserInfo.signatoryFIO
      this.form.signatoryPosition = this.getUserInfo.signatoryPosition
      this.form.signatoryCause    = this.getUserInfo.signatoryCause
      this.form.contacts          = this.getUserInfo.contacts
    },

  },
  watch: {
    getUserInfo(val){
      console.log('Store getUserInfo change:',val)
      this.loadForm()
    }
  },
  computed: {
    ...mapGetters('app',["getUserInfo"]),
    // getUserInfo(){
    //   return this.$store.getters["app/getUserInfo"]
    // }
  },

  inject: ['appRefs'],

  mounted() {
    // console.log('mountedProps')
    this.loadForm()
    // console.log('getUserProps')
    // console.log(this.getUserInfo)
    // console.log('Props page refs',this.$refs)
    // console.log('appRefs',this.appRefs)
  },
  created() {
  },
}
</script>
